import React from 'react';
import { Link } from 'react-router-dom';
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TwitterIcon from "@material-ui/icons/Twitter";
import YouTubeIcon from "@material-ui/icons/YouTube";
import MailIcon from "@material-ui/icons/Mail";

function Footer(props) {
    return (
      <div className="footer" style={{ backgroundColor: "#ff847c" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-4 offset-1 col-sm-2">
              <h5>Links</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/home" style={{ color: "#900c3f" }}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/aboutus" style={{ color: "#900c3f" }}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/menu" style={{ color: "#900c3f" }}>
                    Menu
                  </Link>
                </li>
                <li>
                  <Link to="/contactus" style={{ color: "#900c3f" }}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-7 col-sm-5">
              <h5>Our Address</h5>
              <address>
                777, The great road
                <br />
                Amazing Water Bay, Wonderful avenue
                <br />
                Bengaluru
                <br />
                <i className="fa fa-phone fa-lg"></i>: 080 1234 5678
                <br />
                <i className="fa fa-fax fa-lg"></i>: 080 8765 4321
                <br />
                <i className="fa fa-envelope fa-lg"></i>:{" "}
                <a
                  href="mailto:confusion@food.net"
                  style={{ color: "#900c3f" }}
                >
                  bellysideup@food.net
                </a>
              </address>
            </div>
            <div className="col-12 col-sm-4 align-self-center">
              <div className="text-center">
                <a href="http://www.facebook.com/profile.php?id=">
                  <FacebookIcon color="secondary"></FacebookIcon>
                </a>
                <a href="http://www.linkedin.com/in/">
                  <LinkedInIcon color="secondary"></LinkedInIcon>
                </a>
                <a href="http://twitter.com/">
                  <TwitterIcon color="secondary"></TwitterIcon>
                </a>
                <a href="http://youtube.com/">
                  <YouTubeIcon color="secondary"></YouTubeIcon>
                </a>
                <a href="mailto:">
                  <MailIcon color="secondary"></MailIcon>
                </a>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-auto">
              <p>© Copyright 2020 Belly Side Up</p>
            </div>
          </div>
        </div>
      </div>
    );
}


export default Footer;